import {
  MONTH_REGEX,
  DAY_REGEX,
  YEAR_REGEX,
  WDAYS_REGEX,
  MONTHS,
  WKDAYS
} from './date_matching.js';

export function date_range_extractor(date_exp) {
  let month_first = '';
  let month_last = '';
  let day_first = '';
  let day_last = '';
  let year_first = '';
  let year_last = '';

  // It's only a date line if it mentions one or more of month, year, and day...
  // eslint-disable-next-line no-cond-assign
  if (
    !(
      (month_first = (date_exp.match(MONTH_REGEX) || [null])[0]) &&
      (month_last = (date_exp.match(MONTH_REGEX) || [null]).slice(-1)[0]) &&
      (day_first = (date_exp.match(DAY_REGEX) || [null])[0]) &&
      (day_last = (date_exp.match(DAY_REGEX) || [null]).slice(-1)[0]) &&
      (year_first = (date_exp.match(YEAR_REGEX) || [null])[0]) &&
      (year_last = (date_exp.match(YEAR_REGEX) || [null]).slice(-1)[0])
    )
  ) {
    return null;
  }

  // Extract optional weekday(s)
  let wkday_first = (date_exp.match(WDAYS_REGEX) || [null])[0];
  let wkday_last = (date_exp.match(WDAYS_REGEX) || [null]).slice(-1)[0];

  month_first = MONTHS[month_first.toLowerCase()]; // Convert matched key to full month name
  month_last = MONTHS[month_last.toLowerCase()]; // Convert matched key to full month name

  if (wkday_first) {
    wkday_first = WKDAYS[wkday_first.toLowerCase()] + ', ';
  } // Convert matched key to full weekday name and add comma + space
  if (wkday_last) {
    wkday_last = WKDAYS[wkday_last.toLowerCase()] + ', ';
  } // Convert matched key to full weekday name and add comma + space

  // Find zero-based month numbers (0-11 for Jan - Dec)
  let month_num_first = Object.values(MONTHS).indexOf(month_first);
  let month_num_last = Object.values(MONTHS).indexOf(month_last);

  let start_date = createDate(
    parseInt(year_first, 10),
    month_num_first,
    parseInt(day_first, 10)
  ); // will be null if not a valid date.

  if (!start_date) {
    return null;
  }

  let end_date = createDate(
    parseInt(year_last, 10),
    month_num_last,
    parseInt(day_last, 10)
  );

  if (!end_date) {
    return null;
  } // Impossible, but defensive.

  let day_count = daysBetween(start_date, end_date) + 1; // +1 to make the calculation "inclusive" of the end date.

  let dp = {
    // date properties
    month_first: month_first,
    month_last: month_last,
    day_first: day_first,
    day_last: day_last,
    year_first: year_first,
    year_last: year_last,
    wkday_first: wkday_first,
    wkday_last: wkday_last,
    month_num_first: month_num_first,
    month_num_last: month_num_last,
    start_date: start_date, // date object
    end_date: end_date,
    day_count: day_count
  };

  return dp;
}

// Date cleaning: for each line in the subject text, if it appears to be a date spec, parse the date components and
// replace the whole line with the reformatted date spec.

function createDate(year, month, _date) {
  // Creates a valid Date object or returns null
  var d;
  try {
    d = new Date(year, month, _date);
  } catch (e) {
    return null;
  }
  if (
    d.getFullYear() !== year ||
    d.getMonth() !== month ||
    d.getDate() !== _date
  ) {
    return null;
  }
  return d;
}

function daysBetween(date1, date2) {
  return Math.floor(
    (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24)
  );
}



// WEBPACK FOOTER //
// ./src/date_range_extractor.js